<template>
  <v-tooltip top v-if="application.file.url !== null">
    <v-btn v-if="icon" icon title="Download" v-on:click="download()" slot="activator">
      <v-icon>mdi-download</v-icon>
    </v-btn>
    <span v-else title="Download" v-on:click="download()" slot="activator" style="cursor:pointer">
      Sua {{ application.application_type.name }} foi emitida em {{ application.issued_at | formatDate }}.
      Clique aqui e faça o download
    </span>
    <span>Download do Documento Expedido pelo IMA</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'DownloadFile',
  props: ['application', 'icon'],
  methods: {
    download() {
      window.open(this.application.file.url, '_blank');
    },
  },
};
</script>
